import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  'terms.of.service.page.title': {
    id: 'terms.of.service.page.title',
    defaultMessage: '{platformName} Terms Of Service',
    description: '',
  },
  'terms.of.service.page.button': {
    id: 'terms.of.service.page.button',
    defaultMessage: 'Back',
    description: '',
  },
});

export default messages;
